import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Sparkles, ArrowRight } from "lucide-react";
import { PortalLayout } from "@/components/layout/PortalLayout";
import { GlassCard } from "@/components/GlassCard";
import { SectorBadge, StatusBadge } from "@/components/Badges";
import api from "@/lib/api";
import { goldBtnSm, glassBtn } from "@/lib/constants";

export default function BridgeInbox() {
  const [deals, setDeals] = useState([]);
  const [busy, setBusy] = useState("");
  const load = () => api.get("/bridge/inbox").then((r) => setDeals(r.data));
  useEffect(() => { load(); }, []);

  const classify = async (id) => {
    setBusy(id);
    try { const { data } = await api.post(`/bridge/deals/${id}/classify`); toast.success(`Triage: ${data.classification?.triage}`); load(); }
    catch (e) { toast.error("Classification failed"); } finally { setBusy(""); }
  };
  const move = async (id, stage) => {
    try { await api.post(`/bridge/deals/${id}/move`, { stage }); toast.success(`Moved to ${stage}.`); load(); }
    catch (e) { toast.error("Failed"); }
  };

  return (
    <PortalLayout title="Sourcing Inbox">
      <p className="text-sm text-muted-foreground mb-6 max-w-2xl">Inbound deals from Quantus land here as restricted and unpublished. Review each, run ORLA triage, then move to vetting or underwriting.</p>
      <div className="space-y-4">
        {deals.length === 0 && <GlassCard className="p-10 text-center text-sm text-muted-foreground">Inbox is empty. New Quantus deals will appear here.</GlassCard>}
        {deals.map((d) => (
          <GlassCard key={d.id} className="p-6" data-testid="bridge-inbox-card">
            <div className="flex flex-wrap items-start justify-between gap-4">
              <div>
                <div className="flex items-center gap-3"><SectorBadge sector={d.sector} /><StatusBadge status={d.stage} />{d.orla_triage && <StatusBadge status="published" label={`ORLA: ${d.orla_triage}`} />}</div>
                <h3 className="mt-3 pdg-serif text-xl text-foreground">{d.title}</h3>
                <div className="text-xs text-muted-foreground mt-1">{d.deal_type} &middot; {d.geography} &middot; {d.size_range}</div>
                <p className="mt-2 text-sm text-muted-foreground max-w-xl">{d.teaser}</p>
                {d.orla_classification?.rationale && <p className="mt-2 text-xs text-[hsl(var(--pdg-gold))]">ORLA: {d.orla_classification.rationale}</p>}
              </div>
              <div className="flex flex-col gap-2">
                <button onClick={() => classify(d.id)} disabled={busy === d.id} data-testid={`bridge-classify-${d.id}`} className={goldBtnSm}><Sparkles size={13} /> {busy === d.id ? "Classifying…" : "ORLA triage"}</button>
                <button onClick={() => move(d.id, "vetting")} className={glassBtn + " h-9 px-3 text-xs"}>To vetting <ArrowRight size={12} /></button>
                <button onClick={() => move(d.id, "underwriting")} className={glassBtn + " h-9 px-3 text-xs"}>To underwriting <ArrowRight size={12} /></button>
              </div>
            </div>
          </GlassCard>
        ))}
      </div>
    </PortalLayout>
  );
}
